import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute, retainSearchParams } from "@tanstack/react-router"
import { fallback } from "@tanstack/zod-adapter"
import { z } from "zod"

import { ComputedProductStatus, ProductSortField, SortingOrder } from "@/graphql/codegen/graphql"
import CompanyProductsContainer from "@/screens/Products/containers/CompanyProductsContainer"

const SearchParamsValidator = z.object({
  query: fallback(z.string().optional().default(""), ""),
  field: fallback(z.nativeEnum(ProductSortField), ProductSortField.ProductSupplierDescription),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Desc),
  category: fallback(z.string().optional(), ""),
  statuses: fallback(z.array(z.nativeEnum(ComputedProductStatus)).optional(), undefined),
})

export const Route: AnyRoute = createFileRoute("/app/companies/$companyId/edit/_layout/products")({
  validateSearch: SearchParamsValidator,
  search: {
    middlewares: [retainSearchParams(["query", "field", "order", "category"])],
  },
  component: () => <CompanyProductsContainer />,
})
